
import axios from "axios";

class Endpoint {
	constructor() {
		this.BackendEndBase = process.env.REACT_APP_BACKEND_API;
        this.portal = this.BackendEndBase + 'portal';
        this.credentials = this.BackendEndBase + 'credentials';
        this.customerManagement = this.BackendEndBase + 'customer-management';
	}
}

export const Endpoints =  (new Endpoint());

class API {
    constructor() {
        this.head = async (endpoint, header = {}, config = {}) => {
            return axios.head(
                endpoint,
                {
                    headers: {
                        "Content-Type": "application/json",
                        ...header,
                    },
                    ...config,
                },
            );
        };

        this.get = async (endpoint, header = {}, config = {}) => {
            return axios.get(
                endpoint,
                {
                    headers: {
                        "Content-Type": "application/json",
                        ...header,
                    },
                    ...config,
                },
            );
        };

        this.post = async (endpoint, data, header = {}, config = {}) => {
            return axios.post(endpoint, data, {
                headers: {
                    "Content-Type": "application/json",
                    ...header,
                },
                ...config,
            });
        };

        this.postAnonymous = async (endpoint, data, header = {}, config = {}) => {
            return axios.post(endpoint, data, {
                headers: {
                    "Content-Type": "application/json",
                    ...header,
                },
                ...config,
            });
        };

        this.put = async (endpoint, data, header = {}, config = {}) => {
            return axios.put(endpoint, data, {
                headers: {
                    "Content-Type": "application/json",
                    ...header,
                },
                ...config,
            });
        };

        this.delete = async (endpoint, header = {}, config = {}) => {
            return axios.delete(endpoint, {
                headers: {
                    "Content-Type": "application/json",
                    ...header,
                },
                ...config,
            });
        };
    }
}

export default API;
